import React from "react";
import { Link } from "react-router-dom";

import { ProjectCover } from "../../design-system/components/ProjectCover/ProjectCover";

/**
 * Carte de projet — reprend `.single-work`, la carte du thème déjà utilisée par
 * la section « Derniers Articles » (voir Work.js).
 *
 * On ne redéfinit rien : vignette, overlay corail au survol, titre centré, et
 * surtout le mode sombre, tout vient du thème. Seul `ProjectCover` remplace le
 * <img> pour gérer le repli en dégradé quand le projet n'a pas d'image.
 */
export default function ProjectCard({ project, className = "col-lg-4 col-md-6 col-sm-12" }) {
  return (
    <div className={`single-work ${className}`}>
      <div className="relative">
        <div className="thumb">
          <div className="overlay overlay-bg"> </div>
          <ProjectCover
            title={project.title}
            slug={project.slug}
            src={project.thumbUrl || project.coverUrl}
            accentColor={project.accentColor}
            ratio="fill"
            overlay="none"
            rounded=""
            className="image"
          />
        </div>

        <div className="middle">
          <h4>{project.title}</h4>
          {project.tagline && <div className="cat">{project.tagline}</div>}
        </div>

        <Link className="overlay" to={`/projets/${project.slug}`}> </Link>
      </div>
    </div>
  );
}
